import React from 'react';
import { connect } from 'react-redux';
import { getFormIoFormId } from '../DataEntryForm/redux-objects/actions';
import Form from '../../FormIO/presentation/FormWithValidations';

interface Props {
  getFormIoFormId: () => void;
  dataEntryFormIoFormId: string;
}

class GenericDataEntryForm extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  componentDidMount(): void {
    const { dataEntryFormIoFormId, getFormIoFormId } = this.props;
    if (!dataEntryFormIoFormId) getFormIoFormId();
  }

  render() {
    const { dataEntryFormIoFormId } = this.props;

    return dataEntryFormIoFormId && (
      <Form formId={dataEntryFormIoFormId} />
    )
  }
}

const mapDispatchToProps = {
  getFormIoFormId,
};

const mapStateToProps = (reduxState: any) => {
  return {
    dataEntryFormIoFormId: reduxState.DataEntry.DataEntryFormIoFormId,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GenericDataEntryForm);